import ManageCampaignTable from './ManageCampaignTable'
import ManageCampaignDetails from './ManageCampaignDetails'

const ManageCampaign = {
  Table: ManageCampaignTable,
  Details: ManageCampaignDetails,
}

export default ManageCampaign
